import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3195d8fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "watch-component__header lo-remove-child-margin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NC-Level-One", -1))
const _hoisted_3 = { class: "watch-component__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "watch-component lo-g-gutter--half",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openImage && _ctx.openImage(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.name), 1)
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({
          backgroundImage: `url(${_ctx.data.url})`
        }),
      class: "watch-component__img"
    }, null, 4)
  ]))
}